import React, { useState, useEffect } from 'react';
import { getGeofences, createGeofence, getGeofenceAlertes, detectAnomalies } from '../services/api';
import { FiShield, FiPlus, FiAlertTriangle, FiBell } from 'react-icons/fi';

const Geofencing: React.FC = () => {
    const [tab, setTab] = useState<'zones' | 'alertes' | 'anomalies'>('zones');
    const [geofences, setGeofences] = useState<any[]>([]);
    const [alertes, setAlertes] = useState<any[]>([]);
    const [anomalies, setAnomalies] = useState<any>(null);
    const [showModal, setShowModal] = useState(false);
    const [form, setForm] = useState({ nom: '', description: '', latitude_centre: '', longitude_centre: '', rayon_m: 500, couleur: '#ff0000' });

    useEffect(() => {
        getGeofences().then(res => setGeofences(res.data));
        getGeofenceAlertes({ limit: 50 }).then(res => setAlertes(res.data));
    }, []);

    const handleDetect = async () => {
        const res = await detectAnomalies();
        setAnomalies(res.data);
    };

    const handleCreate = async (e: React.FormEvent) => {
        e.preventDefault();
        await createGeofence(form);
        setShowModal(false);
        getGeofences().then(res => setGeofences(res.data));
    };

    return (
        <div className="page-geofencing">
            <div className="page-header">
                <h2><FiShield /> Geofencing & Monitoring</h2>
                <div className="header-actions">
                    <button className="btn btn-secondary" onClick={handleDetect}><FiAlertTriangle /> Detecter anomalies</button>
                    <button className="btn btn-primary" onClick={() => setShowModal(true)}><FiPlus /> Nouvelle zone</button>
                </div>
            </div>

            <div className="tabs">
                <button className={`tab ${tab === 'zones' ? 'active' : ''}`} onClick={() => setTab('zones')}>Zones ({geofences.length})</button>
                <button className={`tab ${tab === 'alertes' ? 'active' : ''}`} onClick={() => setTab('alertes')}>Alertes ({alertes.length})</button>
                <button className={`tab ${tab === 'anomalies' ? 'active' : ''}`} onClick={() => setTab('anomalies')}>Anomalies</button>
            </div>

            {tab === 'zones' && (
                <div className="cards-grid">
                    {geofences.map(g => (
                        <div key={g.id} className="geofence-card" style={{ borderLeftColor: g.couleur }}>
                            <h4>{g.nom}</h4>
                            <p className="text-muted">{g.description || '-'}</p>
                            <div className="geofence-meta">
                                <span>Type: {g.type}</span>
                                <span>Rayon: {g.rayon_m}m</span>
                                <span>Entree: {g.alerte_entree ? 'Oui' : 'Non'}</span>
                                <span>Sortie: {g.alerte_sortie ? 'Oui' : 'Non'}</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {tab === 'alertes' && (
                <div className="table-container">
                    <table className="data-table">
                        <thead><tr><th>Date</th><th>Commercial</th><th>Zone</th><th>Type</th><th>Message</th></tr></thead>
                        <tbody>
                            {alertes.map(a => (
                                <tr key={a.id}>
                                    <td>{new Date(a.created_at).toLocaleString('fr')}</td>
                                    <td>{a.user_nom}</td>
                                    <td>{a.geofence_nom}</td>
                                    <td><span className={`badge ${a.type === 'entree' ? 'badge-success' : a.type === 'sortie' ? 'badge-danger' : 'badge-warning'}`}>{a.type}</span></td>
                                    <td>{a.message}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {tab === 'anomalies' && (
                <div className="anomalies-section">
                    {!anomalies ? <p className="text-muted">Cliquez sur "Detecter anomalies" pour lancer l'analyse</p> : (
                        <>
                            <h3><FiAlertTriangle /> Inactivite ({anomalies.inactivite?.length || 0})</h3>
                            <div className="anomalies-list">
                                {anomalies.inactivite?.map((a: any) => (
                                    <div key={a.id} className="anomaly-card warning">
                                        <strong>{a.nom}</strong>
                                        <span>Derniere position: {a.derniere_position ? new Date(a.derniere_position).toLocaleString('fr') : 'Aucune aujourd\'hui'}</span>
                                    </div>
                                ))}
                            </div>
                            <h3><FiAlertTriangle /> Faible performance ({anomalies.faible_performance?.length || 0})</h3>
                            <div className="anomalies-list">
                                {anomalies.faible_performance?.map((a: any) => (
                                    <div key={a.id} className="anomaly-card danger">
                                        <strong>{a.nom}</strong>
                                        <span>{a.nb_activites} activites aujourd'hui</span>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            )}

            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal" onClick={e => e.stopPropagation()}>
                        <h3>Nouvelle Zone Geofence</h3>
                        <form onSubmit={handleCreate}>
                            <div className="form-group"><label>Nom</label><input value={form.nom} onChange={e => setForm({ ...form, nom: e.target.value })} required /></div>
                            <div className="form-group"><label>Description</label><textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} rows={2} /></div>
                            <div className="form-row">
                                <div className="form-group"><label>Latitude</label><input type="number" step="any" value={form.latitude_centre} onChange={e => setForm({ ...form, latitude_centre: e.target.value })} required /></div>
                                <div className="form-group"><label>Longitude</label><input type="number" step="any" value={form.longitude_centre} onChange={e => setForm({ ...form, longitude_centre: e.target.value })} required /></div>
                            </div>
                            <div className="form-row">
                                <div className="form-group"><label>Rayon (m)</label><input type="number" value={form.rayon_m} onChange={e => setForm({ ...form, rayon_m: Number(e.target.value) })} /></div>
                                <div className="form-group"><label>Couleur</label><input type="color" value={form.couleur} onChange={e => setForm({ ...form, couleur: e.target.value })} /></div>
                            </div>
                            <div className="modal-actions">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Annuler</button>
                                <button type="submit" className="btn btn-primary">Creer</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Geofencing;
